<template>
  <div class="headerContent" :style="{background:'url('+topBgImg+') no-repeat',height:topHeight}">
    <div class="red-line"></div>
    <div class="colspan">
      <div class="logo headLogoContent" :style="{height:divHeight}" @click="goto">
        <img :class="$store.state.webInfo.style=='yueyang'?'yylogo':'logoImg'" :src="url" />
      </div>
      <div class="searchBox" v-if="style!='yueyang'">
        <el-input placeholder="请输入搜索关键字" v-model="input" @keyup.enter.native="search">
          <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      url: "",
      webconfig: {},
      style: "shaodong",
      topBgImg: require("../../assets/images/shaodong/top-bgimg.png"),
      divHeight: "112px",
      topHeight: "113px",
      input: ""
    };
  },
  created() {
    this.getWebconfigInfo()
      .then(res => {
        this.webconfig = res;
        this.url = this.webconfig.logo_text.url;
        this.style = res.style ? res.style : "";
        if (this.style) {
          if (this.style == "anxiang" || this.style == "yueyang") {
            this.topBgImg = require("../../assets/images/" +
              this.style +
              "/top-bgimg.png");
            this.divHeight = "200px";
            this.topHeight = "200px";
          } else {
            this.topBgImg = require("../../assets/images/" +
              this.style +
              "/top-bgimg.png");
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    goto() {
      this.$router.push({ path: "/" });
    },
    search() {
      this.$router.push({ path: "/search", query: { title: this.input } });
    },
    ...mapActions(["getWebconfigInfo"])
  }
};
</script>
<style lang="less" scoped>
.red-line {
  width: 100%;
  min-width: 1200px;
  height: 2px;
  margin: 0px !important;
}
.colspan {
  margin: 0 auto;
  width: 1200px;
  cursor: pointer;
  .logo {
    width: 380px;
    height: 200px;
    box-sizing: border-box;
    float: left;
    .logoImg {
      height: 110px;
    }
    .yylogo {
      height: 140px ;
    }
  }
  .searchBox {
    width: 252px;
    margin-top: 24px;
    float: right;
    /deep/.el-input__inner {
      height: 30px;
      line-height: 30px !important;
    }
    /deep/ .el-input__icon {
      line-height: 30px;
    }
  }
}
/deep/ .el-input-group__append {
  width: 35px;
  height: 28px;
  //   border: 0;
  padding: 0;
  background-color: #fff;
}
/deep/ .el-icon-search {
  margin-left: 10px;
}
/deep/ .el-input__inner:focus {
  border-color: #dcdfe6;
}
.headLogoContent {
  position: relative;
  img {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Public/head.vue